import { generateMedia } from "styled-media-query";

export const sizes = {
  ipad: "1024px"
};

const display = generateMedia(sizes);

const media = {
  ipad: display.lessThan(sizes.ipad)
};

export default media;



// WEBPACK FOOTER //
// ./src/utils/styleUtils.ts